import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  useFormHandler,
} from "../../../../../../../components";
import { filterEmptyValues } from "../../../../../../../utils/filterEmptyValues";
import { addNewPlacementStart } from "../../../../../../../redux/slices/placements/placementsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../../../../../../hooks/useLoginUser";
import { ENDPOINTS } from "../../../../../../../redux/apiConfig";
import axiosRequest from "../../../../../../../redux/slices/universal/axiosService";

const BillingAndNotifications = ({
  setActiveTab,
  currentPlacement,
  editData,
}) => {
  console.log("currentPlacement", currentPlacement);
  const isEditable = !!editData;
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const { loading, error, employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );
  const [fetchPerticularData, setFetchPerticularData] = useState(null);
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      pointOfContactName: "",
      to: [],
      invoiceBillingAddress: "",
      cc: [],
      bcc: [],
      includeEmailIds: true,
    },
    {
      pointOfContactName: { type: "text" },
      to: { type: "email" },
      cc: { type: "email" },
      bcc: { type: "email" },
      invoiceBillingAddress: { type: "text" },
      includeEmailIds: { type: "toggle" },
    },
  );

  const handleSave = () => {
    const valid = validateAllFields();
    if (valid) {
      const userFormData = {
        billNNotify: {
          POCName: formData.pointOfContactName,
          to: formData.to,
          // billingAddress: formData.invoiceBillingAddress,
          cc: formData.cc,
          bcc: formData.bcc,
          projectEndDate: formData.projectedEndDate,
          includeEmails: formData.includeEmails,
        },
      };
      const uiid = fetchPerticularData?.uiid ?? "";
      const submissionData = filterEmptyValues(userFormData);
      dispatch(
        addNewPlacementStart({
          uiid: uiid,
          rsd: submissionData,
          rsn: "permanetPlacementBillingNotify",
          payload: [
            {
              type: "SET",
              value: {
                invoices: {
                  ...submissionData,
                },
              },
            },
          ],
          onSuccess: async (payload) => {
            setActiveTab((prev) => prev + 1);
          },
        }),
      );
    } else {
    }
  };
  // useEffect(()=>{
  // const permanetPlacementBillingNotify=currentPlacement?.permanetPlacementBillingNotify
  //     if(permanetPlacementBillingNotify){
  //       handleChange("pointOfContactName", permanetPlacementBillingNotify?.billNNotify?.POCName)
  //       handleChange("to", permanetPlacementBillingNotify?.billNNotify?.to)
  //       handleChange("cc", permanetPlacementBillingNotify?.billNNotify?.cc)
  //       handleChange("bcc", permanetPlacementBillingNotify?.billNNotify?.bcc)
  //       handleChange("projectedEndDate", permanetPlacementBillingNotify?.billNNotify?.projectEndDate)
  //       handleChange("includeEmails", permanetPlacementBillingNotify?.billNNotify?.includeEmails)
  //     }
  // },[currentPlacement])
  console.log("currentPlacement", currentPlacement);
  useEffect(() => {
    const fetchEntityDetails = async () => {
      if (!currentPlacement) return;
      const permanentPlacementJobDetails =
        currentPlacement.permanetPlacementJobDetails;
      const { billClient } = permanentPlacementJobDetails || {};
      if (!billClient) return;
      const url = ENDPOINTS.CLIENTS.GET_BY_UIID;
      if (!url) return;
      try {
        const response = await axiosRequest({
          method: "GET",
          url,
          params: {
            coll: "Client",
            fil: JSON.stringify({ uiid: { type: "NONE", value: billClient } }),
            cache: false,
            ret: "generalInfo",
          },
        });
        console.log("Invoice Billing Address fetched successfully:", response);
        if (response?.success) {
          const locations = response?.data?.data?.generalInfo?.locations || [];
          const defaultInvoiceLocation = locations.find(
            (loc) => loc.isDefaultInvoice === true,
          );
          if (defaultInvoiceLocation) {
            const formattedAddress = [
              defaultInvoiceLocation.city,
              defaultInvoiceLocation.state,
              defaultInvoiceLocation.country,
              defaultInvoiceLocation.zipCode,
            ]
              .filter(Boolean)
              .join(" ");
            handleChange("invoiceBillingAddress", formattedAddress);
          }
        }
      } catch (error) {
        console.error("Error fetching entity details:", error);
      }
    };

    fetchEntityDetails();
  }, [currentPlacement]);
  // useEffect(()=>{
  //       const permanetPlacementBillingNotify=currentPlacement?.permanetPlacementBillingNotify||{}
  //      const isEmptyOrMissing =
  //       !permanetPlacementBillingNotify ||
  //       Object.keys(permanetPlacementBillingNotify).length === 0;
  //   const invoices=editData?.invoices||{};
  //     if (isEmptyOrMissing && isEditable) {
  //      handleChange("pointOfContactName",invoices?.billNNotify?.POCName)
  //      handleChange("to",invoices?.billNNotify?.to||[])
  //      handleChange("cc",invoices?.billNNotify?.cc||[])
  //      handleChange("bcc",invoices?.billNNotify?.bcc||[])
  //      handleChange("projectedEndDate",invoices?.billNNotify?.projectEndDate||"")
  //      handleChange("includeEmails",invoices?.billNNotify?.includeEmails||"")
  //     }
  //     },[isEditable])
  useEffect(() => {
    const fetchData = async () => {
      const uiid =
        currentPlacement?.uiid ??
        editData?.uiid ??
        currentPlacement?.data?.doc?.uiid ??
        "";
      if (!uiid) return;
      const filter = {
        uiid: { type: "NONE", value: uiid },
      };
      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
          params: {
            coll: "Placement",
            fil: JSON.stringify(filter),
            ret: "invoices.billNNotify uiid",
            // ref: "InvDoc",
            // incl: "uiid businessName",
          },
        });
        const data = response?.data?.data;
        if (data) {
          const invoices = data?.invoices || {};
          const billNNotify = invoices?.billNNotify || {};

          setFetchPerticularData(data);

          if (billNNotify.POCName) {
            handleChange("pointOfContactName", billNNotify.POCName);
          }

          if (Array.isArray(billNNotify.to) && billNNotify.to.length > 0) {
            handleChange("to", billNNotify.to);
          }

          if (Array.isArray(billNNotify.cc) && billNNotify.cc.length > 0) {
            handleChange("cc", billNNotify.cc);
          }

          if (Array.isArray(billNNotify.bcc) && billNNotify.bcc.length > 0) {
            handleChange("bcc", billNNotify.bcc);
          }

          if (billNNotify.projectEndDate) {
            handleChange("projectedEndDate", billNNotify.projectEndDate);
          }

          if (billNNotify.includeEmails) {
            handleChange("includeEmails", billNNotify.includeEmails);
          }

          if (billNNotify.billingAddress) {
            handleChange("invoiceBillingAddress", billNNotify.billingAddress);
          }
        }
      } catch (error) {
        setFetchPerticularData(null);
        console.error("Failed to fetch placement data:", error);
      }
    };

    fetchData();
  }, [currentPlacement, isEditable]);
  return (
    <div className="px-8 py-5">
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 max-w-7xl ">
        <div>
          <FormFieldSet
            type="text"
            title={"Point of Contact Name"}
            placeholder="Enter Point Of Contact Name"
            value={formData.pointOfContactName}
            onChange={(value) => handleChange("pointOfContactName", value)}
            error={errors.pointOfContactName}
          />
        </div>
        <div>
          <FormFieldSet
            type="email"
            title={"To :-(Please type and enter)"}
            placeholder="Enter To"
            value={formData.to}
            onChange={(value) => handleChange("to", value)}
            error={errors.to}
            multiple
          />
        </div>
        <div className="col-span-2 lg:col-span-1 lg:row-span-2">
          <FormFieldSet
            type="textArea"
            title={"Invoice Billing Address"}
            placeholder="Enter Billing Address"
            value={formData.invoiceBillingAddress}
            onChange={(value) => handleChange("invoiceBillingAddress", value)}
            error={errors.invoiceBillingAddress}
            rows={5}
            disabled={true}
          />
        </div>
        <div>
          <FormFieldSet
            type="email"
            title={"CC :-(Please type and enter)"}
            placeholder="Enter CC"
            value={formData.cc}
            onChange={(value) => handleChange("cc", value)}
            error={errors.cc}
            multiple
          />
        </div>
        <div>
          <FormFieldSet
            type="email"
            title={"BCC :-(Please type and enter)"}
            placeholder="Enter BCC"
            value={formData.bcc}
            onChange={(value) => handleChange("bcc", value)}
            error={errors.bcc}
            multiple
          />
        </div>
      </div>
      <div className="mt-6">
        <FormFieldSet
          type="toggle"
          title={""}
          label={"Include Email Id’s from client record while Invoicing."}
          labelPosition={"after"}
          isChecked={formData?.includeEmailIds}
          value={formData?.includeEmailIds}
          onChange={() =>
            handleChange("includeEmailIds", !formData.includeEmailIds)
          }
          error={errors.includeEmailIds}
          size="sm"
        />
      </div>
      <div className="flex gap-3 justify-end mt-6">
        <Button title={"Cancel"} variant="outlined" />
        <Button title={"Save"} onClick={() => handleSave()} />
      </div>
    </div>
  );
};

export default BillingAndNotifications;
